import React, { useEffect, useState } from "react";
import { useTranslation } from 'react-i18next';
import finalReportAnimated from "../../../assets/images/finalReportAnimated.svg";
import download from "../../../assets/images/download.svg";
import "./topContent.css";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import { useNavigate } from "react-router-dom";

import emergenteUno from "../../../assets/images/emergenteUno.svg";
import emergenteDos from "../../../assets/images/emergenteDos.svg";
import emergenteTres from "../../../assets/images/emergenteTres.svg";
import consolidadoUno from "../../../assets/images/consolidadoUno.svg";
import consolidadoDos from "../../../assets/images/consolidadoDos.svg";
import consolidadoTres from "../../../assets/images/consolidadoTres.svg";
import expertoUno from "../../../assets/images/expertoUno.svg";
import expertoDos from "../../../assets/images/expertoDos.svg";
import expertoTres from "../../../assets/images/expertoTres.svg";
import { IconInstagram } from "../../Icons/IconInstagram";
import { IconLinkedin } from "../../Icons/IconLinkedin";
import { PdfDownload } from "../../PdfDownload/PdfDownload";
import OurServicesReport from "../OurServicesReport/OurServicesReport";
import { downloadPdf } from "../../../utils/pdfUtils";
import { formatText } from "../../../utils/formatText";

type ITopContent = {
  name: string;
  level: number;
  sublevel: number;
};

const TopContent = ({ name, level, sublevel }: ITopContent) => {
  const {t} = useTranslation()
  const [levelData, setLevelData] = useState<any>({});
  const navigate = useNavigate();

  const levelDescription = [
    {
      level: 1,
      sublevel: 1,
      logo: emergenteUno,
      characteristics: [
        t('finalReport.characteristics_1'),
        t('finalReport.characteristics_2'),
        t('finalReport.characteristics_3'),
      ],
      summary:
        t('finalReport.summary_1'),
      description:
        t('finalReport.description_1'),
      description2:
        t('finalReport.description2_1'),
    },
    {
      level: 1,
      sublevel: 2,
      logo: emergenteDos,
      characteristics: [
        t('finalReport.characteristics_1'),
        t('finalReport.characteristics_2'),
        t('finalReport.characteristics_3'),
      ],
      summary:
        t('finalReport.summary_1'),
      description:
        t('finalReport.description_1'),
      description2:
        t('finalReport.description2_1'),
    },
    {
      level: 1,
      sublevel: 3,
      logo: emergenteTres,
      characteristics: [
        t('finalReport.characteristics_1'),
        t('finalReport.characteristics_2'),
        t('finalReport.characteristics_3'),
      ],
      summary:
        t('finalReport.summary_1'),
      description:
        t('finalReport.description_1'),
      description2:
        t('finalReport.description2_1'),
    },
    {
      level: 2,
      sublevel: 1,
      logo: consolidadoUno,
      characteristics: [
        t('finalReport.characteristics_4'),
        t('finalReport.characteristics_5'),
        t('finalReport.characteristics_6'),
      ],
      summary:
        t('finalReport.summary_2'),
      description:
        t('finalReport.description_2'),
      description2:
        t('finalReport.description2_2'),
    },
    {
      level: 2,
      sublevel: 2,
      logo: consolidadoDos,
      characteristics: [
        t('finalReport.characteristics_4'),
        t('finalReport.characteristics_5'),
        t('finalReport.characteristics_6'),
      ],
      summary:
        t('finalReport.summary_2'),
      description:
        t('finalReport.description_2'),
      description2:
        t('finalReport.description2_2'),
    },
    {
      level: 2,
      sublevel: 3,
      logo: consolidadoTres,
      characteristics: [
        t('finalReport.characteristics_4'),
        t('finalReport.characteristics_5'),
        t('finalReport.characteristics_6'),
      ],
      summary:
        t('finalReport.summary_2'),
      description:
        t('finalReport.description_2'),
      description2:
        t('finalReport.description2_2'),
    },
    {
      level: 3,
      sublevel: 1,
      logo: expertoUno,
      characteristics: [
        t('finalReport.characteristics_7'),
        t('finalReport.characteristics_8'),
        t('finalReport.characteristics_9'),
      ],
      summary:
      t('finalReport.summary_3'),
      description:
      t('finalReport.description_3'),
      description2:
      t('finalReport.description2_3'),
      description3:
      t('finalReport.description3_1'),
    },
    {
      level: 3,
      sublevel: 2,
      logo: expertoDos,
      characteristics: [
        t('finalReport.characteristics_7'),
        t('finalReport.characteristics_8'),
        t('finalReport.characteristics_9'),
      ],
      summary:
      t('finalReport.summary_3'),
      description:
      t('finalReport.description_3'),
      description2:
      t('finalReport.description2_3'),
      description3:
      t('finalReport.description3_1'),
    },
    {
      level: 3,
      sublevel: 3,
      logo: expertoTres,
      characteristics: [
        t('finalReport.characteristics_7'),
        t('finalReport.characteristics_8'),
        t('finalReport.characteristics_9'),
      ],
      summary:
      t('finalReport.summary_3'),
      description:
      t('finalReport.description_3'),
      description2:
      t('finalReport.description2_3'),
      description3:
      t('finalReport.description3_1'),
    },
  ];

  useEffect(() => {
    const levelFounded = foundLevel(level, sublevel);
    setLevelData(levelFounded);
  }, [level, sublevel]);

  const foundLevel = (level: number, sublevel: number) => {
    const optionFounded = levelDescription.find(
      (e) => e.level === level && e.sublevel === sublevel
    );
    return optionFounded || "";
  };

  // const downloadPdf = () => {
  //   const input = document.getElementById("finalTest"); // The ID of the div you want to download as PDF
  //   html2canvas(input!).then((canvas) => {
  //     const imgData = canvas.toDataURL("image/png");
  //     const pdf = new jsPDF({
  //       orientation: "landscape",
  //     });
  //     const imgProps = pdf.getImageProperties(imgData);
  //     const pdfWidth = pdf.internal.pageSize.getWidth();
  //     const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;
  //     pdf.addImage(imgData, "PNG", 0, 0, pdfWidth, pdfHeight);
  //     pdf.save("informeFinalTestExportador.pdf");
  //   });
  // };

  return (
    <>
    <div id="finalTest" className="topContentMainContainer">
        <div className="finalTest__flex mainSquareContainer">
          <div className="topDataContainer">
            <div>
              <h5 className="subtitleText">{t('finalReport.title')}</h5>
              <h2 className="actualLevelTitleText">{t(name)}</h2>
              <div className="characteristicsContainer">
                <p className="characteristicsLabelTitle">{t('finalReport.features')}:</p>
                {levelData?.characteristics?.map((item: any) => (
                  <div className="characteristicsItem">
                    <div className="circleItem" />
                    <p>{item}</p>
                  </div>
                ))}
              </div>
            </div>
            <img src={levelData?.logo} className="levelImage" />
          </div>
          <div className="summaryContainer">
            <p>{levelData?.summary}</p>
          </div>
          <div className=" descriptionContainer">  
              <p>{levelData?.description}</p>
              <p>{levelData?.description2}</p>
              <p>{levelData?.description3}</p>
          </div>
          <div className="divider" />
          <div className="footerSquareContainer">
            <div onClick={() => downloadPdf('divToPrint', 'informeFinalTestExportador.pdf')}>
              <img src={download} alt="download" />
              <a className="downloadText">{t('finalReport.footer.link')}</a>
            </div>
            <div
              onClick={() => navigate("/exportertest")}
              className="editFormButton"
            >
              <a>{t('finalReport.footer.button')}</a>
            </div>
          </div>
        </div>
        <div className="finalTest__fixed">
          <img src={finalReportAnimated} alt="final-report-animation" />
        </div>
    </div>

    <PdfDownload className="pdf-test" headerTitle={t('exporterTest.header.title')} referenceName='#34343434'>
        <div className="pdf_a4_content">
          <div className="pdf_a4_test_top">
            <div className="pdf_a4_test_top_right">
            <img src={levelData?.logo} className="pdf_a4_test_top_img" />
            </div>
            <div className="pdf_a4_test_top_left">
              <p className="pdf_a4_content_subtitle">{t('finalReport.title')}</p>
              <h3 className="pdf_a4_content_title">{t(name)}</h3>

              <div className="pdf_a4_content_characteristics">
                <p className="pdf_a4_content_characteristics_title">{t('finalReport.features')}:</p>
                {levelData?.characteristics?.map((item: any) => (
                  <div className="pdf_a4_content_characteristics_item">
                    <div className="pdf_a4_content_characteristics_circle" />
                    <p className="pdf_a4_content_characteristics_text">{item}</p>
                  </div>
                ))}
              </div>

            </div>
          </div>

          <div className="pdf_a4_content_summary">
                <p>{levelData?.summary}</p>
              </div>

              <div className="pdf_a4_content_description">  
                <p>{levelData?.description}</p>
                <p>{levelData?.description2}</p>
                <p>{levelData?.description3}</p>
            </div>
          
        </div>


        <OurServicesReport { ... { name, level, sublevel } }  />


        <div className="pdf_a4_footer">
          <div className="pdf_a4_footer_top">
            <div className="pdf_a4_footer_text" dangerouslySetInnerHTML={{ __html: formatText(t('exporterTest.download.text_1')) }}  >
              {/* <p>Para consultas o comentarios sobre la herramienta, contáctenos en:  <span>info@interconectar.eu</span></p> */}
            </div>
            <div className="pdf_a4_alert">
              <div className="icon">
              <svg width="23" height="21" viewBox="0 0 23 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <g clip-path="url(#clip0_5640_372)">
                  <path d="M13.6093 10.2382V8.53484H8.90097C8.87741 8.48315 8.85254 8.43145 8.82898 8.38105C10.1563 7.41048 11.4835 6.4412 12.8108 5.47062C12.8017 5.41893 12.7925 5.36853 12.7833 5.31683H10.4586C11.4835 4.2377 12.4273 3.24386 13.4522 2.16602C12.9993 2.14405 12.5896 2.12466 11.9692 2.09494C12.9326 1.33373 13.7637 0.678497 14.6224 0C15.4706 0.672035 16.29 1.3221 17.2456 2.07943C16.6579 2.11303 16.2547 2.1363 15.7887 2.16214C16.8136 3.20121 17.7966 4.19763 18.8687 5.28194H16.4563C16.434 5.33492 16.4118 5.38662 16.3895 5.43961C17.7207 6.41276 19.0532 7.38463 20.5376 8.47023H15.6722V10.224H22.2667C22.2851 10.4837 22.3073 10.6505 22.3073 10.8172C22.3086 13.8116 22.3086 16.8073 22.3047 19.8018C22.3047 20.0835 22.4107 20.4428 21.9107 20.4428C20.1488 20.4389 18.387 20.4415 16.5283 20.4415C17.3202 19.7901 18.0558 19.237 18.7299 18.618C19.4773 17.9304 19.9944 17.0917 20.1659 16.0707C20.3085 15.2293 20.0742 14.6594 19.315 14.2239C17.9249 13.4252 16.3686 13.1887 14.8057 13.0362C11.9037 12.7532 8.99783 12.5218 6.09456 12.253C5.73067 12.2194 5.36809 12.1108 5.01991 11.9945C4.52774 11.8304 4.60104 11.5215 4.94922 11.307C5.29348 11.0937 5.6914 10.9477 6.08409 10.8288C8.09334 10.2201 10.1615 10.1878 12.2388 10.2369C12.6721 10.2472 13.1067 10.2382 13.6106 10.2382H13.6093Z" fill="#387E22"/>
                  <path d="M0 10.2638H5.02247C4.36538 10.4086 3.73053 10.5365 3.10092 10.6929C2.82866 10.7601 2.52105 10.8299 2.31947 11.0005C2.04197 11.2357 1.66892 11.5704 1.67285 11.8573C1.67678 12.1533 2.03019 12.6146 2.32471 12.7064C3.35486 13.0243 4.41512 13.2763 5.48192 13.4379C7.24377 13.7067 9.02265 13.8695 10.7884 14.1151C11.2112 14.1732 11.6353 14.3335 12.0189 14.5248C13.0215 15.0262 13.2165 15.8779 12.3605 16.5758C11.4848 17.2905 10.507 17.9793 9.45722 18.3709C7.36551 19.1502 5.21489 19.8028 3.04464 20.3366C2.1035 20.5679 1.05502 20.3754 0 20.3754V10.2612L0 10.2638Z" fill="#387E22"/>
                  </g>
                  <defs>
                  <clipPath id="clip0_5640_372">
                  <rect width="22.3125" height="20.4531" fill="white"/>
                  </clipPath>
                  </defs>
              </svg>

              </div>
              <p className="pdf_a4_alert_text">{t('exporterTest.download.alert_text')}</p>
            </div>
          </div>
          
          <div className=" pdf_a4_footer_bottom  pdf_a4_footer--col">
            <div className="pdf_a4_footer_left">
              <span className="pdf_a4_footer_link">https://www.exportopia.eu/</span>
              <span className="pdf_a4_footer_ig"><IconInstagram /> exportopia</span>
              <span className="pdf_a4_footer_in"><IconLinkedin /> Exportopia</span>
            </div>
            <div className="pdf_a4_footer_paginator">
              <span className="pdf_a4_footer_paginator_text">{t('price_comparator.download.pagination.page')}</span>
              <span className="pdf_a4_footer_paginator_actual">{ 1}</span>
              <span className="pdf_a4_footer_paginator_div"> {t('price_comparator.download.pagination.of')} </span>
              <span className="pdf_a4_footer_paginator_lenght">{ 1}</span>
            </div>
          </div>
        </div>
      </PdfDownload>
  </>
    
  );
};

export default TopContent;
